import Fade from '@mui/material/Fade';
import { TransitionProps } from '@mui/material/transitions';
import { forwardRef, useState } from 'react';
import { SAVED_ARTEFACT_EXIT_TRANSITION_DURATION } from './constants';
import { getSavedNavItemPosition } from './utils';

export const SaveArtefactTransitionComponent = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  const [transitionStyles, setTransitionStyles] = useState({});
  const savedNavItemPosition = getSavedNavItemPosition();
  const translateX =
    Math.abs(window.innerWidth - savedNavItemPosition.width) / 2;
  const translateY = Math.abs(window.innerHeight / 2 - savedNavItemPosition.y);

  const setTransition = () => {
    setTransitionStyles(() => {
      return {
        transform: `translate3d(-${translateX}px,-${translateY}px,0) scale(0)`,
        transition:
          'all ' + SAVED_ARTEFACT_EXIT_TRANSITION_DURATION + 'ms ease',
        transitionProperty: 'transform, opacity',
      };
    });
  };

  return (
    <>
      <Fade
        ref={ref}
        {...props}
        style={transitionStyles}
        timeout={{
          exit: SAVED_ARTEFACT_EXIT_TRANSITION_DURATION,
        }}
        onExiting={setTransition}
      />
    </>
  );
});
